import React from 'react';
import {withStyles} from '@material-ui/core';
import AdminUpgradeIcon from '../../Icons/Subscription/AdminUpgradeIcon';

const styles = (theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 116,
        minHeight: 29,
        borderRadius: 6,
        borderStyle: 'solid',
        borderWidth: 3.5,
        borderImageSource: 'linear-gradient(106deg, #bb7bfd -39%, #8645f9 59%)',
        borderImageSlice: 1,
        backgroundImage: 'linear-gradient(to bottom, #fff, #fff), linear-gradient(106deg, #bb7bfd -39%, #8645f9 59%)',
        cursor: 'pointer',
        pointerEvents: 'auto'
    },
    text: {
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        fontFamily: 'Rubik',
        fontSize: 14,
        marginLeft: 6,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 0.3,
        color: '#8645f9',
    },
    icon: {
        marginTop: 1
    }
})
const colors = {
    firstColor: '#bb7bfd',
    secondColor: '#8645f9'
}

const AdminUpgradeButtonView = (props) => {
    const {classes, containerStyle, translations, onClick} = props

    return (
        <div data-intrcm-id="AdminUpgradeButton_cp11mfke" onClick={onClick} className={[classes.container, containerStyle].join(" ")}>
            <div data-intrcm-id="AdminUpgradeButton_0c1bof7h" className={classes.icon}>
                <AdminUpgradeIcon 
                    width={24}
                    height={20}
                    firstColor={colors.firstColor}
                    secondColor={colors.secondColor}
                />
            </div>
            <div data-intrcm-id="AdminUpgradeButton_w1uyryu6" className={classes.text}>{translations.upgrade.toUpperCase()}</div>
        </div>
    )
}

export const AdminUpgradeButton = withStyles(styles, {withTheme: true})(AdminUpgradeButtonView)